export default "__VITE_ASSET__Bg$IMrXr__"